export default __webpack_public_path__ + "static/media/trusted.a9d6e2d9.svg";